import { useState } from 'react';
import { LogoMark, btn, input } from '../components/ui.js';
import { requestOtp, verifyOtp } from '../lib/internal.js';

export function Login({ onSignIn }: { onSignIn: (t: string) => void }) {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [step, setStep] = useState<'email' | 'code'>('email');
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-neutral-950 p-6">
      <div className="pointer-events-none absolute -top-24 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-emerald-500/20 blur-3xl" />
      <div className="relative w-full max-w-sm rounded-2xl border border-white/10 bg-neutral-900/80 p-7 shadow-2xl backdrop-blur-xl">
        <div className="mb-1 flex items-center gap-2.5">
          <LogoMark size={28} />
          <h1 className="brand text-xl text-white">
            Commission<span className="text-emerald-400">Sight</span>
          </h1>
          <span className="rounded-full bg-white/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-emerald-300 ring-1 ring-white/15">
            Admin
          </span>
        </div>
        <p className="mb-5 text-sm text-neutral-400">Staff sign-in — admin allowlist only.</p>
        {error && (
          <p className="mb-3 rounded bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</p>
        )}
        {step === 'email' ? (
          <div className="space-y-3">
            <input
              className={input}
              placeholder="staff@commissionsight.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              type="button"
              className={btn}
              onClick={async () => {
                setError(null);
                try {
                  await requestOtp(email);
                  setStep('code');
                } catch (e) {
                  setError(e instanceof Error ? e.message : 'Failed');
                }
              }}
            >
              Send code
            </button>
          </div>
        ) : (
          <div className="space-y-3">
            <input
              className={input}
              placeholder="6-digit code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            <button
              type="button"
              className={btn}
              onClick={async () => {
                setError(null);
                try {
                  const res = await verifyOtp(email, code);
                  if (res.role !== 'admin') {
                    setError('This account is not an admin.');
                    return;
                  }
                  onSignIn(res.token);
                } catch (e) {
                  setError(e instanceof Error ? e.message : 'Invalid code');
                }
              }}
            >
              Verify & sign in
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
